import { TabBar } from "@/components/TabBar";
import { Outlet } from "react-router-dom";
export const LayoutRoot = () => {
  return <>
      <Outlet data-sentry-element="Outlet" data-sentry-source-file="index.tsx" />
      <TabBar data-sentry-element="TabBar" data-sentry-source-file="index.tsx" />
    </>;
};